import {
  CSGetRecentClients,
  CSGetSelectedEntityId as GET_SELECTED_ENTITY_ID,
  updateUser as UPDATE_USER,
  recentClientsInVar,
  selectedEntityIdInVar,
} from '@admiin-com/ds-graphql';
import { gql, useMutation, useQuery } from '@apollo/client';
import { useEffect, useMemo } from 'react';
import { MAX_RECENT_CLIENTS } from '../../../constants/config';
import { CSGetEntity as GET_ENTITY } from '@admiin-com/ds-graphql';
import { useCurrentUser } from '../../../hooks/useCurrentUser/useCurrentUser';
import { useNonAccountEntities } from '../../../hooks/useUserEntities/useUserEntities';
import { useNavigate } from 'react-router-dom';
import { PATHS } from '../../../navigation/paths';
export function useEntitySelect() {
  const { data: selectedEntityIdData } = useQuery(gql(GET_SELECTED_ENTITY_ID));
  const entityId = selectedEntityIdData?.selectedEntityId || '';
  const navigate = useNavigate();
  const { data: recentClientIdsData } = useQuery(gql(CSGetRecentClients));
  const recentClientIds: string[] = useMemo(
    () => recentClientIdsData?.recentClients || [],
    [recentClientIdsData]
  );

  const { error } = useQuery(gql(GET_ENTITY), {
    variables: { id: entityId },
    skip: !entityId,
  });

  const user = useCurrentUser();
  const [updateUser] = useMutation(gql(UPDATE_USER));

  useEffect(() => {
    if (
      !recentClientIds.includes(entityId) &&
      entityId &&
      user.firmId &&
      user.firmId !== entityId
    )
      updateRecentClients(entityId);
  }, [recentClientIds, entityId, user.firmId]);

  const { entities } = useNonAccountEntities();

  const firstEntityId = entities[0]?.id;
  useEffect(() => {
    if (!entityId || error) {
      const defaultEntityId =
        user.selectedEntityId ??
        user.firmId ??
        user?.onboardingEntity ??
        firstEntityId ??
        '';
      if (defaultEntityId) {
        changeEntityId(defaultEntityId);
      }
    }
  }, [entityId, error, firstEntityId, user]);

  const changeEntityId = async (selectedId: string) => {
    if (!user.firmId || user.firmId === selectedId) {
      selectedEntityIdInVar(selectedId);
      localStorage.setItem('selectedEntityId', selectedId);

      if (user?.id && user.selectedEntityId !== selectedId) {
        try {
          await updateUser({
            variables: {
              input: {
                id: user.id,
                selectedEntityId: selectedId,
              },
            },
          });
        } catch (err) {
          console.log('ERROR updating user selected entity', err);
        }
      }
    } else {
      const isClient = user.firmId && user.firmId !== selectedId;
      if (isClient) {
        updateRecentClients(selectedId);
        navigate(`${PATHS.clients}/${selectedId}`);
      }
    }
  };

  const updateRecentClients = (selectedEntityId: string) => {
    let updatedRecentClients = [...recentClientIds];

    updatedRecentClients = updatedRecentClients.filter(
      (id) => id !== selectedEntityId
    );

    updatedRecentClients.unshift(selectedEntityId);

    updatedRecentClients = updatedRecentClients.slice(0, MAX_RECENT_CLIENTS);
    recentClientsInVar(updatedRecentClients);
    localStorage.setItem('recentClients', JSON.stringify(updatedRecentClients));
  };

  return changeEntityId;
}
